<template>
  <m-matching :t-id="tId" :zone-id="zoneId" data-qe-id="matching" />
</template>

<script setup lang="ts">
import MMatching from '@/modules/MMatching.vue'

defineProps<{ tId: string; zoneId: string }>()

document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
</script>

<style lang="less"></style>
